import { DesignSystemButton, type IconButtonProps } from '@mathflat/design-system-2024'
import clsx from 'clsx'
import { forwardRef } from 'react'

import { Icon } from '@/component/atoms/Icon'
import type * as icons from '@/component/atoms/Icon/svg/index'

import { iconButtonStyle } from './IconButton.style'

type Props = {
  icon: keyof typeof icons
  /** 아이콘만 있어 이름이 없다 — 스크린리더·테스트가 쓸 이름을 받는다 */
  'aria-label'?: string
}

const IconButton = forwardRef<HTMLButtonElement, IconButtonProps & Props>((props, ref) => {
  const { icon, size, variant, ...rest } = props

  const buttonClassName = clsx('button', `button-${size}`, `button-${variant}`)

  return (
    <DesignSystemButton
      css={iconButtonStyle}
      className={buttonClassName}
      size={size}
      ref={ref}
      {...rest}
    >
      <Icon name={icon} />
    </DesignSystemButton>
  )
})

IconButton.displayName = 'IconButton'
export default IconButton
